<template>
  <div class="exchange_list">
    <div class="deco">
      <h2 class="access_hidden">포인트 전환 상세 내역</h2>
      <period-setting :cateArr="cateArr"></period-setting>
      <div v-if="exchangeList.list && exchangeList.list.length" class="list">
        <table>
          <col class="contents" />
          <col class="state" />
          <thead>
            <tr class="access_hidden">
              <th class="contents">처리 일시, 내용</th>
              <th class="state">금액, 종류</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(el, idx) in exchangeList.list" :key="idx">
              <td class="contents">
                <span v-if="el.regDate" class="date">{{ el.regDate }}</span>
                <span class="content">{{ getContent(el.content) }}</span>
              </td>
              <td class="state">
                <span class="status" :class="stateClass(el.exchangeStatus)">
                  {{ getExchangeStatus(el.exchangeStatus) }}
                </span>
                <span class="point">
                  {{ addComma(el.exchangePoint) }}
                </span>
                <span class="bt">
                  <v-button
                    @handleClick="handleClick(idx)"
                    class="btn06"
                    :text="$t('common.btnDesc')"
                    obj="exchangeHistory_detail"
                    :opt="`{&quot;servicename&quot;:&quot;${serviceUrl}&quot;}`"
                    @click.native="handleA2S"
                  />
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination
          @custom-change="changeOffset"
          :offset="exchangeList.pageNo"
          :total-item-cnt="exchangeList.totalCount"
          :list-item-size="10"
          :page-size="exchangeList.pageSize"
        >
        </pagination>
      </div>
      <p v-else class="none"><v-icon clsName="icon_none" /><span v-html="errorMessage"></span></p>
    </div>
    <div v-if="userRegion === 'krpc'">
      <h3 class="attention_title">{{ $t('exchangeHistory.caution.title') }}</h3>
      <ul class="attention" v-html="$t('exchangeHistory.caution.content')" />
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin';
import { mapActions, mapGetters } from 'vuex';
import PeriodSetting from '@/components/modules/exchangeHistory/PeriodSetting';
import Pagination from '@/components/modules/common/Pagination';
import VIcon from '@/components/atoms/VIcon';
import VButton from '@/components/atoms/VButton';
import { exchangeHistoryErrorMsg } from '@/utils/errorMsg';
import sendLog from '@/utils/analistic';
import eventBus from '@/utils/eventBus';
import { checkUserRegion } from '@/utils';
import { EXCHANGE_STATUS_CLASS } from '@/consts/consts';

export default {
  mixins: [mixin],
  components: {
    PeriodSetting,
    Pagination,
    VIcon,
    VButton,
  },
  data() {
    return {
      errorMessage: '',
    };
  },
  computed: {
    ...mapGetters(['serviceUrl']),
    ...mapGetters('exchange', [
      'exchangeList',
      'exchangeListPageSize',
      'exchangeListPageNo',
      'exchangeListStartDate',
      'exchangeListEndDate',
      'exchangeListStatus',
    ]),
    userRegion() {
      return checkUserRegion();
    },
    cateArr() {
      return this.$i18n.t('exchangeHistory.statusList');
    },
    getContent() {
      return ({ chargeType, chargeTypeName: contentType, extraInfo, regDate: date = '' }) => {
        // regDate = format 2023.04.12
        let year = '';
        let month = '';
        let day;

        if (date) {
          const dataObj = new Date(date.replace(/\./g, '/'));
          year = dataObj.getFullYear();
          month = dataObj.getMonth() + 1;
          day = dataObj.getDate();

          if (month < 10) {
            month = `0${month}`;
          }

          if (day < 10) {
            day = `0${day}`;
          }

          if (this.$i18n.locale !== 'ko' && this.$i18n.locale !== 'ko-KR') {
            // 2023.01.04 -> MM/DD/YYYY
            date = `${month}/${day}/${year}`;
          }
        }

        return this.$i18n.t(`pointHistory.${contentType}`, { date, year, month });
      };
    },
    getExchangeStatus() {
      return (status) => {
        if (status === -1) {
          return '';
        }
        return this.$t(`exchangeHistory.statusList.${status}`);
      };
    },
  },
  watch: {
    $route(to, from) {
      if (to.path !== from.path) {
        this.init();
      }
    },
  },
  created() {
    this.init();
  },
  mounted() {
    eventBus.$on('listUpdate', this.listUpdate);
  },
  beforeDestroy() {
    eventBus.$off('listUpdate', this.listUpdate);
  },
  methods: {
    ...mapActions('exchange', [
      'getBankList',
      'getExchangeHistory',
      'getExchangeHistory2',
      'setExchangeListPageNo',
      'setExchangeListStartDate',
      'setExchangeListEndDate',
      'setExchangeDetail',
    ]),
    async init() {
      await this.listUpdate();
      this.getBankList();
    },
    historyParameter() {
      return {
        startDate: this.exchangeListStartDate,
        endDate: this.exchangeListEndDate,
        exchangeStatus: this.exchangeListStatus,
        pageNo: this.exchangeListPageNo,
        pageSize: this.exchangeListPageSize,
      };
    },
    async changeOffset(offset) {
      this.setExchangeListPageNo(offset);
      const apiReturn = await this.getExchangeHistory(this.historyParameter());
      this.errorMessage = exchangeHistoryErrorMsg(apiReturn);
    },
    stateClass(val) {
      return EXCHANGE_STATUS_CLASS.PLUS.includes(val)
        ? 'plus'
        : EXCHANGE_STATUS_CLASS.MINUS.includes(val)
        ? 'minus'
        : '';
    },
    handleClick(val) {
      // window.scrollBy(0, 1);
      this.setExchangeDetail(val);
    },
    handleA2S(e) {
      sendLog(e.target.attributes.obj.value, JSON.parse(e.target.attributes.opt.value));
    },
    async listUpdate() {
      this.setExchangeListEndDate(this.$moment().format('YYYY-MM-DD'));
      this.setExchangeListStartDate(this.$moment().add(-1, 'months').add(1, 'days').format('YYYY-MM-DD'));

      const apiReturn = await this.getExchangeHistory(this.historyParameter());
      this.errorMessage = exchangeHistoryErrorMsg(apiReturn);
    },
  },
};
</script>
